import { render } from "./DispBlockComponent.vue?vue&type=template&id=4c7abf08&scoped=true"
import script from "./DispBlockComponent.vue?vue&type=script&lang=js"
export * from "./DispBlockComponent.vue?vue&type=script&lang=js"

import "./DispBlockComponent.vue?vue&type=style&index=0&id=4c7abf08&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c7abf08"

export default script